import axios from 'axios';

export const apiRequest = axios.create({
  baseURL: import.meta.env.VITE_ACCOUNT_API_HOST,
  withCredentials: true,
});

export const apiSkeziaRequest = axios.create({
  baseURL: import.meta.env.VITE_SKEZIA_API_HOST,
  withCredentials: true,
});
